const dns_management = {
	error_while_fetching_dns_records:
		"Er is een fout opgetreden bij het ophalen van de DNS-records. Als het probleem aanhoudt, neem dan contact op met onze klantenservice.",
	external_nameservers:
		"De DNS-records kunnen niet worden bewerkt omdat dit domein externe nameservers gebruikt.",
	not_available:
		"De DNS-records zijn niet beschikbaar, omdat het domein niet (meer) onder uw beheer staat.",
	title: "DNS beheren",
	update_success: "De nieuwe DNS-instellingen zijn succesvol opgeslagen.",
};

export default dns_management;
